module.exports = __webpack_public_path__ + "img/allCoin.5095434e.png";